
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host .dropdown-item-separator {
  display: flex;
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  padding-top: 8px;
  padding-bottom: 8px;
  margin-left: 16px;
  margin-right: 16px;
  font-size: var(--slh-base-xs-font-size, 14px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  min-height: var(--slh-base-xxs-line-height, 24px);
  font-family: var(--slh-default-font-family, "Open Sans");
  font-weight: var(--slh-base-bold-font-weight, 700);
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
}

:host(:not(:first-of-type)) .dropdown-item-separator {
  padding-top: 16px;
  margin-top: 8px;
  border-top: 1px solid var(--slh-color-neutral-shade-20, #EBEEF4);
}
`;
